export const bcfModel = {
  supportedModelUnits: ['in', 'ft', 'm', 'cm', 'mm'],
  supportedModelType: ['ifc', 'rvt']
};

export const ISSUE_MORE_THAN = 'issues more than ';
